import { Point } from "./Point";
import { Rectangle } from "./Rectangle";
import { IDraggingOffsets } from "./IDraggingOffsets";
import { Size } from "./Size";
import { Vector } from "./Vector";

export class DraggingOffsets<TSource> {
  constructor(
    public source: TSource,
    public relocatingOffset: Point = new Point(0, 0),
    public transformingRatesFromCenter: Rectangle = new Rectangle(new Point(1, 1), new Size(1, 1)),
    public transformingVector: Vector = null) {
  }

  static from<TSource>(source: IDraggingOffsets<TSource>): DraggingOffsets<TSource> {
    return new DraggingOffsets(
      source.source,
      Point.from(source.relocatingOffset),
      Rectangle.from(source.transformingRatesFromCenter),
      Vector.from(source.transformingVector)
    );
  }

  static to<TSource>(source: DraggingOffsets<TSource>): IDraggingOffsets<TSource> {
    return {
      source: source.source,
      relocatingOffset: Point.to(source.relocatingOffset),
      transformingRatesFromCenter: Rectangle.to(source.transformingRatesFromCenter),
      transformingVector: Vector.to(source.transformingVector),
    };
  }
}
